import { createSlice } from '@reduxjs/toolkit';

interface LeadsState {
  leads: any[];
  loading: boolean;
}

const initialState: LeadsState = {
  leads: [],
  loading: false,
};

const leadsSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {
    setLeads: (state, action) => {
      state.leads = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLeads, setLoading } = leadsSlice.actions;
export default leadsSlice.reducer;
